import { InjectionToken, Injector } from '@angular/core';
import { Constants } from '../core/Constants';
import { Helper } from '../shared/helper';

let AppInjector: Injector;
export let getAppInjector = (): Injector => AppInjector;
export let setAppInjector = (injector: Injector) => { AppInjector = injector; };

export const BRAND = new InjectionToken<string>('branding');
export const API_ENDPOINT = new InjectionToken<string>('api endpoint');
export const API_MYM_ENDPOINT = new InjectionToken<string>('mym api endpoint');
export const API_CMS_ENDPOINT = new InjectionToken<string>('cms api endpoint');


export const getCurrentEndpoint = function(): string {
  const brand = Helper.getCurrentSiteBrand();
  let api = Constants.API_ENDPOINT;
  if (brand !== Constants.BRAND_B2B) {
    api += `/brand/${brand}`;
  }
  return api;
};
